"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteAddApiForTenant = siteAddApiForTenant;
exports.siteApproveApiForTenant = siteApproveApiForTenant;
exports.siteBuildListApiForTenant = siteBuildListApiForTenant;
exports.siteChangeApiForTenant = siteChangeApiForTenant;
exports.siteCloneApiForTenant = siteCloneApiForTenant;
exports.siteCopyUrlApiForTenant = siteCopyUrlApiForTenant;
exports.siteDeleteApiForTenant = siteDeleteApiForTenant;
exports.siteDownloadUrlApiForTenant = siteDownloadUrlApiForTenant;
exports.siteEditApiForTenant = siteEditApiForTenant;
exports.siteEditSaveApiForTenant = siteEditSaveApiForTenant;
exports.siteFilterApiForTenant = siteFilterApiForTenant;
exports.siteListApiForTenant = siteListApiForTenant;
exports.sitePauseApiForTenant = sitePauseApiForTenant;
exports.sitePlayApiForTenant = sitePlayApiForTenant;
exports.siteReadApiForTenant = siteReadApiForTenant;
exports.siteRestrictApiForTenant = siteRestrictApiForTenant;
exports.siteSaveApiForTenant = siteSaveApiForTenant;
exports.siteSubmitApiForTenant = siteSubmitApiForTenant;
exports.siteUnrestrictApiForTenant = siteUnrestrictApiForTenant;
exports.siteUpdateApiForTenant = siteUpdateApiForTenant;
exports.siteViewConfigApiForTenant = siteViewConfigApiForTenant;
exports.siteViewEditorListApiForTenant = siteViewEditorListApiForTenant;
exports.siteViewSnapshotsApiForTenant = siteViewSnapshotsApiForTenant;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _tenant = require("../../../../constants/endpoints/tenant");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * controller site add
 * @param payload
 * @returns api response
 * @description this function used to controller site add.
 */
function siteAddApiForTenant(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SiteService.site.add), params);
}

/**
 * controller site edit
 * @param payload
 * @returns api response
 * @description this function used to controller site edit.
 */
function siteEditSaveApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.edit), params);
}

/**
 * controller site edit
 * @param payload
 * @returns api response
 * @description this function used to controller site edit.
 */
function siteEditApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.edit), params);
}

/**
 * controller site read
 * @param payload
 * @returns api response
 * @description this function used to controller site read.
 */
function siteReadApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.read), params);
}

/**
 * controller site change
 * @param payload
 * @returns api response
 * @description this function used to controller site change.
 */
function siteChangeApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.change), params);
}

/**
 * controller site update
 * @param payload
 * @returns api response
 * @description this function used to controller site update.
 */
function siteUpdateApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.update), params);
}

/**
 * controller list sites
 * @param payload
 * @returns api response
 * @description this function used to bulk controller list sites.
 */
function siteListApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.list), params);
}

/**
 * controller site submit
 * @param payload
 * @returns api response
 * @description this function used to controller site submit.
 */
function siteSubmitApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.submit), params);
}

/**
 * controller site approve
 * @param payload
 * @returns api response
 * @description this function used to controller site approve.
 */
function siteApproveApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.approve), params);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteDeleteApiForTenant(params) {
  return api.delete("".concat(_app.default.baseUrl + _tenant.SiteService.site.delete), params);
}

/**
 * controller site clone
 * @param payload
 * @returns api response
 * @description this function used to controller site clone.
 */
function siteCloneApiForTenant(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SiteService.site.clone), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteSaveApiForTenant(params) {
  return api.create("".concat(_app.default.baseUrl + _tenant.SiteService.site.save), params);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteBuildListApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.buildList), params);
}

// apis not available for below

/**
 * controller site update
 * @param payload
 * @returns api response
 * @description this function used to controller site update.
 */
function siteFilterApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.filter), params);
}

/**
 * controller list sites
 * @param payload
 * @returns api response
 * @description this function used to bulk controller list sites.
 */
function sitePauseApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.pause), params);
}

/**
 * controller site submit
 * @param payload
 * @returns api response
 * @description this function used to controller site submit.
 */
function sitePlayApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.play), params);
}

/**
 * controller site approve
 * @param payload
 * @returns api response
 * @description this function used to controller site approve.
 */
function siteCopyUrlApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.copyUrl), params);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteDownloadUrlApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.downloadEmail), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteRestrictApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.restricted), params);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteUnrestrictApiForTenant(params) {
  return api.update("".concat(_app.default.baseUrl + _tenant.SiteService.site.unrestricted), params);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteViewSnapshotsApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.viewSnapshots), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteViewEditorListApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.viewEditorList), params);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteViewConfigApiForTenant(params) {
  return api.get("".concat(_app.default.baseUrl + _tenant.SiteService.site.viewConfig), params);
}